class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.mqlSmall = window.matchMedia('(max-width: 990px)');
    this.mqlSmall.addEventListener('change', this.onMediaChange.bind(this));

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    if (!this.mqlSmall.matches || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);
      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    } else {
      if (this.dataset.open === undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    if (this.mqlSmall.matches && !this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute('open');
    }
  }

  onMediaChange(event) {
    if (event.matches) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);
